(() => {
  let e = () => {
    var e =
      document.querySelector(".collection-grid-section") ||
      document.querySelector(".section-search");
    new ResizeObserver((e) => {
      var t,
        o,
        [,] = e;
      (e = document.querySelector(".facets__top")),
        (t = document.querySelector(".facets__sort-wrapper")),
        (o = document.querySelector(".collection-wrapper")),
        e &&
          t &&
          o &&
          ((o.style.gridTemplateRows =
            t.getBoundingClientRect().height > e.getBoundingClientRect().height
              ? t.getBoundingClientRect().height + "px auto 1fr"
              : e.getBoundingClientRect().height + "px auto 1fr"),
          e.setAttribute(
            "style",
            `--sort-width: ${t.getBoundingClientRect().width}px`,
          ));
    }).observe(e);
  };
  document.addEventListener("shopify:section:load", function () {
    e();
  }),
    e();
})();
